<template>
    <div class="container-fluid" id="dvcrud">
        <visualizadorestoque :idproduto="idprodutoestoque" :descricao="descproestoque"></visualizadorestoque>
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>                        
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                        <export-excel style="display: none;" id="btexportarexcel"
                            :data   = "lstfornecedores"
                            :fields = "json_fields"
                            name    = "fornecedores.xls">
                        </export-excel>                         
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Exportar cadastros" style="margin-right: 10px;" @click.prevent="mtdexportarexcel()"><span aria-hidden="true"><i class="fa fa-upload"></i></span></button>                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Importar cadastro de fornecedores" style="margin-right: 10px;" @click.prevent="mtdrotinaimportacao()"><span aria-hidden="true"><i class="fa fa-download"></i></span></button>                        
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Nome/Razão Social</option>
                                    <option value="2">Fantasia</option>
                                    <option value="3">CNPJ/CPF</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-6 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                         ref="reflstfornecedores"
                                        :rows="lstfornecedores"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="cnpjcpf_f" slot-scope="item">
                                        {{ formatacpfcnpj(item.row.cpfcnpj) }}
                                    </template>
                                    <template slot="opcoes" slot-scope="item">
                                        <div class="d-flex">
                                            <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                            <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                            <button type="button" class="btn btn-secondary btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexibehistoricocompras(item.row)"><i class="fa fa-shopping-basket"></i></button>
                                        </div>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstfornecedores.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <!-- PAGINADOR -->
                            <div class="col-8 col-sm-4 col-md-8 col-lg-8" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <!-- BUTTON OUTROS -->
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">                        
                                <div class="dropdown">
                                    <button type="button" class="btn btn-info btn-sm btn-block dropdown-toggle" data-toggle="dropdown">
                                        <i class="fa fa-navicon"></i> Outras
                                    </button>                                   
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinacampos()"><i class="fa fa-list"></i> Atribuir campos</a>
                                    </div>
                                </div>
                            </div>
                            <!-- BUTTON LISTAR -->
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="container-fluid">
                        <div class="row" style="margin-top: 10px;">
                            <!-- CP TIPO -->
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="cbtipo">Tipo:</label>
                                    <select class="form-control form-control-sm" id="cbtipo" v-model="vtipo"
                                            v-bind:disabled="ativadesativa1">
                                            <option value="0">Pessoa Física</option>
                                            <option value="1">Pessoa Jurídica</option>
                                            <option value="2">Extrangeiro</option>
                                    </select>
                            </div>
                            <!-- CP TIPO CONTRIBUINTE -->
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtipocontribuinte">Tipo de Contribuinte:</label>
                                <select class="form-control form-control-sm" id="cbtipocontribuinte" v-model="vtipocontribuinte"
                                        v-bind:disabled="ativadesativa">
                                    <option value="1">Contribuinte ICMS</option>
                                    <option value="2">Contribuinte ISENTO</option>
                                    <option value="9">Não Contribuinte</option>
                                </select>
                            </div>
                            <!-- CP CATEGORIA -->
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <span class="lblselect2">Categoria:</span>
                                <select id="cbcategoria" data-placeholder="Selecione uma categoria" v-model="vidcategoria" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                                                        
                        </div>
                    </div>
                    <div class="card-body" v-show="parseInt(vtipo) == 0 || parseInt(vtipo) == 2">
                        <div class="row">
                            <!-- CP ID FISICO -->
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edidfisico">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edidfisico" v-model="vid"
                                    maxlength="20" disabled/>
                            </div>
                            <!-- CP NOME -->
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="ednome">*Nome Completo:</label>
                                <input type="text" v-model="vnomerazaosocial" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="ednome" maxlength="50">
                            </div>
                            <!-- CP CPF -->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edcpf">*CPF:</label>
                                <input type="text" v-model="vcpfcnpj" v-bind:disabled="ativadesativa1"
                                    class="form-control form-control-sm" id="edcpf" maxlength="20">                                   
                            </div>
                            <!-- CP RG -->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edrg">RG:</label>
                                <input type="text" v-model="vrgie" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edrg" maxlength="20"
                                    v-mask="'#######################'">
                            </div>
                            <!-- CP FONE1 -->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edfone1f">*Telefone 1:</label>
                                <input type="text" v-model="vfone1" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edfone1f" maxlength="20"
                                    v-mask="'(##)#####-####'">
                            </div>
                            <!-- CP FONE2 -->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edfone2f">Telefone 2:</label>
                                <input type="text" v-model="vfone2" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edfone2f" maxlength="20"
                                    v-mask="'(##)#####-####'">
                            </div>
                            <!-- CP EMAIL -->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edemailfcad">*E-mail:</label>
                                <input type="email" v-model="vemail" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edemailfcad" maxlength="100">
                            </div>
                            <!-- CP SITE -->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edsitef">Site:</label>
                                <input type="text" v-model="vsite" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edsitef" maxlength="50">
                            </div>
                            <!-- CP DTNASCIMENTO -->
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddtnascimento">*Data de Nascimento:</label>
                                <date-picker id="eddtnascimento" v-model="vdtnascimentofundacao" :config="options" class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
                            </div>
                            <!-- CP ATIVO -->
                            <div class="col-sm-12 col-md-2 col-lg-2">
                            <label for="cbativo">*Ativo:</label>
                            <select class="form-control form-control-sm" id="cbativo" v-model="vativo"
                                    v-bind:disabled="ativadesativa">
                                    <option value="0">Sim</option>
                                    <option value="1">Não</option>
                            </select>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" v-show="parseInt(vtipo) == 1">
                        <div class="row">
                            <!-- CP ID JURIDICO -->
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edidjuridico">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edidjuridico" v-model="vid"
                                    maxlength="20" disabled/>
                            </div>
                            <!-- CP RAZAOSOCIAL -->
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="edrazaosocial">*Razão Social:</label>
                                <input type="text" v-model="vnomerazaosocial" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edrazaosocial" maxlength="50">
                            </div>
                            <!-- CP CNPJ FORNECEDOR -->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edcnpjfornecedor">*CNPJ:</label>
                                <div class="input-group" style="z-index: 1;">
                                    <input type="text" v-model="vcpfcnpj" v-bind:disabled="ativadesativa1"
                                        class="form-control form-control-sm" id="edcnpjfornecedor" maxlength="20">
                                    <div class="input-group-append" @click.prevent="contultacnpj()" style="cursor: pointer">
                                        <span class="input-group-text"><i class="fa fa-gavel"></i></span>
                                    </div>
                                </div>
                               
                            </div>
                            <!-- CP FANTASIA -->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edfantasia">Fantasia:</label>
                                <input type="text" v-model="vfantasia" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edfantasia" maxlength="50">
                            </div>
                            <!-- CP INSCRIÇÃO ESTADUAL -->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edie">Inscrição Estadual:</label>
                                <input type="text" v-model="vrgie" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edie" maxlength="20"
                                    v-mask="'#######################'">
                            </div>
                            <!-- CP FONE1 -->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edfone1j">*Telefone 1:</label>
                                <input type="text" v-model="vfone1" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edfone1j" maxlength="20"
                                    v-mask="'(##)#####-####'">
                            </div>
                            <!-- CP FONE2 -->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edfone2j">Telefone 2:</label>
                                <input type="text" v-model="vfone2" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edfone2j" maxlength="20"
                                    v-mask="'(##)#####-####'">
                            </div>
                            <!-- CP EMAIL -->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edemailj">*E-mail:</label>
                                <input type="email" v-model="vemail" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edemailj" maxlength="100">
                            </div>
                            <!-- CP SITE -->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edsitej">Site:</label>
                                <input type="text" v-model="vsite" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edsitej" maxlength="50">
                            </div>
                            <!-- CP CONTATO -->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edcontato">Contato:</label>
                                <input type="text" v-model="vcontato" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edcontato" maxlength="50">
                            </div>
                            <!-- CP INSCRIÇÃO SUFRAMA -->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edinscricaosuframa">Insc. Suframa:</label>
                                <input type="text" v-model="vinscricaosuframa" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edinscricaosuframa" maxlength="20"
                                    v-mask="'#########################'">
                            </div>
                            <!-- CP FUNDAÇÃO -->
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddtfundacao">*Data de Fundação:</label>
                                <date-picker id="eddtfundacao" v-model="vdtnascimentofundacao" :config="options" class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
                            </div>
                            <!-- CP ATIVO -->
                            <div class="col-sm-12 col-md-2 col-lg-2">
                            <label for="cbativo">*Ativo:</label>
                            <select class="form-control form-control-sm" id="cbativo" v-model="vativo"
                                    v-bind:disabled="ativadesativa">
                                    <option value="0">Sim</option>
                                    <option value="1">Não</option>
                            </select>
                            </div>                      
                        </div>
                    </div>
                    <div class="col-md-12" style="margin-top: 15px; margin-botton: 15px; border: 10px;">
                            <ul class="nav nav-tabs">
                                <li class="nav-item">
                                    <a class="nav-link active" data-toggle="tab" href="#dvendereco">Endereço</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" data-toggle="tab" href="#dvobservacoes">Observações</a>
                                </li>
                            </ul>
                            <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                <div class="tab-pane container-fluid active" id="dvendereco">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-2 col-lg-2">
                                            <label for="edcep">*CEP:</label>
                                            <input type="text" v-mask="'#####-###'" class="form-control form-control-sm"
                                                   id="edcep" v-model="vcep" v-bind:disabled="ativadesativa"
                                                   data-bv-group=".group" maxlength="10">
                                        </div>
                                        <div class="col-sm-12 col-md-4 col-lg-4">
                                            <label for="edlogradouro">*Logradouro:</label>
                                            <input type="text" class="form-control form-control-sm" id="edlogradouro"
                                                   v-model="vlogradouro" v-bind:disabled="ativadesativa"
                                                   data-bv-group=".group" maxlength="100">
                                        </div>
                                        <div class="col-sm-12 col-md-2 col-lg-2">
                                            <label for="ednumeroendereco">*Número:</label>
                                            <input type="text" class="form-control form-control-sm" id="ednumeroendereco"
                                                   v-model="vnumeroendereco" v-bind:disabled="ativadesativa"
                                                   data-bv-group=".group" maxlength="20">
                                        </div>
                                        <div class="col-sm-12 col-md-4 col-lg-4">
                                            <label for="edreferencia">Referência:</label>
                                            <input type="text" class="form-control form-control-sm" id="edreferencia"
                                                   v-model="vreferencia" v-bind:disabled="ativadesativa"
                                                   data-bv-group=".group" maxlength="100">
                                        </div>

                                        <div :class="parseInt(vtipo) !== 2 ? 'col-sm-12 col-md-6 col-lg-6' : 'col-sm-12 col-md-4 col-lg-4'">
                                            <span class="lblselect2">*Bairro:</span>
                                            <select id="cbbairro" v-model="vidbairro" v-bind:disabled="ativadesativa"
                                                    data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                    style="width:100%;">
                                            </select>
                                        </div>
                                        <div class="col-sm-12 col-md-4 col-lg-4">
                                            <span class="lblselect2">*Município:</span>
                                            <select id="cbmunicipio" v-model="vidmunicipio"
                                                    v-bind:disabled="ativadesativa"
                                                    data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                    style="width:100%;">
                                            </select>
                                        </div>
                                        <div class="col-sm-12 col-md-2 col-lg-2">
                                            <span class="lblselect2">*UF:</span>
                                            <select id="cbuf" v-model="viduf" v-bind:disabled="ativadesativa"
                                                    data-placeholder="Selecione a UF" data-allow-clear="true"
                                                    style="width:100%;">
                                            </select>
                                        </div>
                                        <div v-show="parseInt(vtipo) === 2" class="col-sm-12 col-md-2 col-lg-2">
                                            <span class="lblselect2">*País:</span>
                                            <select id="cbpais" v-model="vidpais"
                                                    v-bind:disabled="ativadesativa"
                                                    data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                    style="width:100%;">
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane container-fluid" id="dvobservacoes">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <textarea class="form-control center" rows="6" id="txtobs" v-model="vobs" v-bind:disabled="ativadesativa"></textarea>
                                        </div>									
                                    </div>
                                </div>
                            </div>
						</div>
                        <div class="card-footer" style="margin-top: 20px;">
                        <div class="row">
                            <!-- TEXTO -->
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <!-- BUTTON GRAVAR -->
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <!-- BUTTON CANCELAR -->
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pnimportacao" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">IMPORTAÇÃO DE CADASTRO DE FORNECEDORES</span>                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body" style="padding: 30px;">
                        <div class="row">
                                <div class="col-md-12" style="padding-bottom: 15px!important;">
                                    <h1 style="color: #0acf97!important;" class="text-info">Importação de cadastro</h1>
                                </div>
                                <div class="col-md-12">
                                    <p style="text-indent: 1.5em; font-size: 14px; color: #666;">
                                        Para este procedimento uma matriz de arquivo no formato do EXCEL(.xls) está disponibilizada para download. Basta clicar no link a baixo para baixá-la.
                                        Preencha a mesma com os dados corretamente, sem alterar as posições das colunas.
                                        Após o preenchimento, salve os dados e clique em "Enviar arquivo". Aguarde o processamento, ao final o sistema irá listar o resultado da importação.</p>
                                    <p style="font-size: 14px; color: #666; margin-left: 50px;">
                                        Campos de CNPJ, telefone, CEP, devem ser informados somente os números, sem formatação;<br>
                                        Campo de Data deve ser informados no formato dd/mm/aaaa, sendo que os mesmos devem estar formatados como texto no EXCEL (utilize a fórmula <strong>=TEXTO(A1; "dd/mm/aaaa")</strong>, em seguida copiar e colar especial).<br>
                                    </p>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div class="custom-control custom-checkbox chbajuste">
                                        <input type="checkbox" class="custom-control-input" id="cblimpardados" v-model="vlimpardados">
                                        <label class="custom-control-label" for="cblimpardados" style="color: #f82b54;">Limpar cadastro existente</label>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <input type="file" id="btselecionararqenviar" accept=".xls" style="display: none;">
                                </div>
                                <div class="col-md-2">
                                    <button type="button" class="btn btn-green" @click.prevent="mtdbaixarmatriz()" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;">
                                        <img src="@/assets/matrizexcel.png">
                                        Baixar matriz
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <input
                                        type="file" 
                                        id="ipselecionararquivo"
                                        accept=".xls" 
                                        @change="mtdselecionararquivo" 
                                        style="display: none;"
                                        ref="if_selecionarquivo">                                    
                                    <button type="button" @click="$refs.if_selecionarquivo.click()" class="btn btn-blue" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;"><i class="fa fa-upload"></i>
                                        Enviar arquivo
                                    </button>
                                </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10">
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdcancelaredicao()"><i class="fa fa-close"></i> Cancelar</button>
                            </div>
                        </div>
                    </div>                                        
                </div>

                <!-- MODAL IMPORTAÇÃO -->
                <div class="modal fade" id="mdatribuircampos" tabindex="-1">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                        <div class="modal-content">
                            <div class="modal-header">
                                <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir campos aos produtos</h4>
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                            </div>
                            <div class="modal-body" style="padding-top: 5px;">
                                <div class="row">
                                    <!-- CHECK BOX TIPO CONTRIBUINTE -->
                                    <div class="col-sm-1 col-md-1 col-lg-1">
                                        <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                            <input type="checkbox" class="custom-control-input" id="cbatribuirtipocontribuinte" v-model="vatribuirtipocontribuinte">
                                            <label class="custom-control-label" for="cbatribuirtipocontribuinte"></label>
                                        </div>
                                    </div>
                                    <!-- CP ATRIBUIR TIPO CONTRIBUINTE  -->
                                    <div class="col-sm-11 col-md-5 col-lg-5">
                                        <label for="cbtipocontribuintecampos">Tipo de Contribuinte:</label>
                                        <select class="form-control form-control-sm" id="cbtipocontribuinte" v-model="vtipocontribuintecampos" v-bind:disabled="!vatribuirtipocontribuinte">
                                            <option value="1">Contribuinte ICMS</option>
                                            <option value="2">Contribuinte ISENTO</option>
                                            <option value="9">Não Contribuinte</option>
                                        </select>
                                    </div>
                                    <!-- CHECK BOX CATEGORIA -->
                                    <div class="col-sm-1 col-md-1 col-lg-1">
                                        <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                            <input type="checkbox" class="custom-control-input" id="cbatribuircategoria" v-model="vatribuircategoria">
                                            <label class="custom-control-label" for="cbatribuircategoria"></label>
                                        </div>
                                    </div>
                                    <!-- CP CATEGORIA -->
                                    <div class="col-sm-11 col-md-5 col-lg-5">
                                        <span class="lblselect2">Categoria:</span>
                                        <select id="cbcategoriacampos" data-placeholder="Selecione uma categoria" v-model="vcategoriacampos" v-bind:disabled="!vatribuircategoria" data-allow-clear="true" style="width:100%;">
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button id="btconfirmar" type="button" @click.prevent="mtdatribuircampos()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>
                                <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

          <!-- - Modal para exibir compra-->
          <div class="modal fade" id="mdlcompras" tabindex="-1">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-hist-compras">
                <div class="modal-content" style="max-height: 85vh;">
                    <!--Cabeçalho do modal-->
                    <div class="modal-header">
                        <i class="fa fa-shopping-basket" style="margin-top: 8px; margin-right: 7px"></i>
                        <h3 class="modal-title" style="color: #fff;">
                            Histórico de Compras
                        </h3>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="container-fluid" style="margin-block: 10px;">
                        <div class="row mb-2">
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="edconteudopesq">Código:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="vidfornecedorhist" disabled>
                            </div>
                            <div class="col-sm-12 col-md-9 col-lg-9">
                                <label for="edconteudopesq">Fornecedor:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="vdescfornecedorhist"  disabled>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="cbperiodovendas">Periodo:</label>
                                <select name="cbperiodovendas" class="form-control form-control-sm" id="cbperiodovendas" v-model="pfiltrodatavenda">
                                    <option value="0">Não</option>
                                    <option value="1" >Data de entrada</option>
                                    <option value="2" >Data de emissão</option>
                                    <option value="3" selected>Data de efetivação</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="eddtini">De:</label>
                                <div class="input-group">
                                    <date-picker id="eddtini" v-model="pdtinicompra" :config="options" 
                                    class="form-control form-control-sm" v-bind:disabled="parseInt(pfiltrodatavenda) == 0"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="eddtfim">Até:</label>
                                <div class="input-group">
                                    <date-picker id="eddtfim" v-model="pdtfimcompra" :config="options" 
                                    class="form-control form-control-sm" v-bind:disabled="parseInt(pfiltrodatavenda) == 0"></date-picker>
                                    <div class="input-group-append">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>
                                </div>
                            </div>
                          

                            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdpesquisarhitoricocompras()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                        </div>
                    </div>

                    <!--Corpo do modal-->
                    <div class="modal-body" style="max-height: 400px; overflow-y: auto;">
                        <div v-show="!isloadinghistcompras" class="col-md-12" style="margin-top: 10px;">
                            <vue-bootstrap4-table ref="reflstcomprasfor"
                                    :rows="lstcomprasfor"
                                    :columns="columnshiscomprasfor"
                                    :config="configh"
                                    :classes="classes">
                                <template slot="empty-results">
                                    <div class="col-md-12 text-center">Sem dados para visualização</div>
                                </template>
                                <!-- ícones de ordenação da table -->
                                <template slot="sort-asc-icon">
                                    <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                </template>
                                <template slot="sort-desc-icon">
                                    <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                </template>
                                <template slot="no-sort-icon">
                                    <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                </template>

                                <template slot="slot_qtd_estoque" slot-scope="item">
                                    <span v-if="parseFloat(item.row.saldo) === 0" class="text-black-50 font-weight-bolder" style="font-size: 16px; cursor: pointer;" title="Produto sem saldo">{{ item.row.saldo }}</span>
                                    <span v-else-if="parseFloat(item.row.saldo) < 0" class="font-weight-bolder" style="color: #f82b54; font-size: 16px; cursor: pointer;" title="Produto com saldo negativo">{{ item.row.saldo }}</span>
                                    <template v-else>
                                        <span class="font-weight-bolder" style="color: #0acf97; font-size: 16px; cursor: pointer;" title="Produto com saldo">{{ item.row.saldo }}</span>
                                    </template>
                                </template>

                                <template slot="id_cp" slot-scope="item">
                                    {{ item.row.idproduto }}
                                </template>
                                <template slot="opcoes" slot-scope="item">
                                    <button type="button" class="btn btn-info btn-sm" @click.prevent="mtdvisualizarestoque(item.row)" style="width: 35px; margin-right: 8px">
                                        <i class="fa fa-cubes" aria-hidden="true"></i>
                                    </button>
                                </template>
                               
                            </vue-bootstrap4-table>
                        </div>
                        <div v-show="isloadinghistcompras" class="col-md-12" style="margin-top: 10px;">
                            <vue-bootstrap4-table ref="reflstcomprasfor"
                                    :rows="[{}, {}, {}]"
                                    :columns="columnshiscomprasfor"
                                    :config="configh"
                                    :classes="classes">
                                <template slot="empty-results">
                                    <div class="col-md-12 text-center">Sem dados para visualização</div>
                                </template>
                                <!-- ícones de ordenação da table -->
                                <template slot="sort-asc-icon">
                                    <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                </template>
                                <template slot="sort-desc-icon">
                                    <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                </template>
                                <template slot="no-sort-icon">
                                    <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                </template>
                                <!--  -->
                                <template slot="id_cp" slot-scope="item">
                                    {{ item.row.id }}
                                </template>
                          
                                <template slot="slot_descricao" slot-scope="item">
                                    <skeleton-loader-vue type="rect" :width="300" :height="20" animation="fade" />
                                </template>
                                <template slot="slot_qtd_estoque" slot-scope="item">
                                    <skeleton-loader-vue type="rect" :width="50" :height="20" animation="fade" />
                                </template>
                                <template slot="slot_qtd_vend" slot-scope="item">
                                    <skeleton-loader-vue type="rect" :width="100" :height="20" animation="fade" />
                                </template>
                            </vue-bootstrap4-table>
                        </div>
                    </div>
                    
                    <!--Rodapé do modal-->
                    <div class="modal-footer">
                        <div class="dropdown">
                            <button type="button" class="btn btn-info btn-sm btn-block dropdown-toggle" data-toggle="dropdown">
                                <i class="fa fa-navicon"></i> Exportar
                            </button>                                   
                            <div class="dropdown-menu">
                                <a class="dropdown-item" href="#" @click.prevent="mtdexportahistoricocompra(false)"><i class="fa fa-print"></i> Imprimir</a>
                                <a class="dropdown-item" href="#" @click.prevent="mtdexportahistoricocompra(true)"><i class="fa fa-file-excel-o"></i> Excel</a>
                            </div>
                        </div>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-sign-out"></i> Sair</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'
    import VisualizadorEstoque from '../components/cmpvisualizadorestoque'

    export default {
        name: 'cadfornecedores',
        components:{
            VueBootstrap4Table,
            vPagination,
            'visualizadorestoque'   : VisualizadorEstoque,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                lstfornecedores            : [],
                pfiltro                    : 1,
                pconteudo                  : '',
                pqtdregistros              : 10,
                pqtd_paginas               : 1,
                pagina_atual               : 1,
                pqtd_total_registros       : 0,

                //VARIÁVIES DO CRUD
                opcrud                     :  0,
                vid                        : '',
                vcpfcnpj                   : '',
                vrgie                      : '',
                vnomerazaosocial           : '',
                vfone1                     : '',
                vfone2                     : '',
                vemail                     : '',
                vsite                      : '',
                vdtnascimentofundacao      : '',
                vcontato                   : '',
                vinscricaosuframa          : '',
                vfantasia                  : '',
                vlogradouro                : '',
                vnumeroendereco            : '',
                vidbairro                  : '',
                vidmunicipio               : '',
                viduf                      : '',
                vidpais                    : '',
                vreferencia                : '',
                vcep                       : '',
                vobs                       : '',
                vtipo                      :  1,
                vtipocontribuinte          :  9,
                vativo                     :  0,
                vidcategoria               : null,

                pfiltrodatavenda           : 0, 


                //modal compras fornecedor
                lstcomprasfor          : [],
                vidfornecedorhist      : '',
                vdescfornecedorhist    : '',
                idprodutoestoque       : 0,
                descproestoque         : '',
                
                isloadinghistcompras   : false,
                pfiltrodatacompra      : "1",
                pdtinicompra           : util.DataAtual(true),
                pdtfimcompra           : util.DataAtual(true),

                // VARIÁVEIS PARA ATRIBUIR CAMPOS
                vatribuircategoria         : false,
                vcategoriacampos           : null,

                vatribuirtipocontribuinte  : false,
                vtipocontribuintecampos    : 9,

                //variável da importação
                vlimpardados               : false,
                arqselecionado             : null,

                //variável para habilitação dos campos
                ativadesativa              : true,
                ativadesativa1             : true,
                
                //variáveis para exportação para o excel
                //caso queira exportar todo o conteúdo não informar o json_fields na declaração do componente
                json_fields: {
                            'Código'      : 'id',
                            'Nome'        : 'nomerazaosocial',
                            'Fantasia'    : 'fantasia',
                            'CPF/CNPJ'    : 'cpfcnpj',
                            'RG/IE'       : 'rgie',
                            'CEP'         : 'cep',
                            'Logradouro'  : 'logradouro',
                            'Nr.:'        : 'numeroendereco',
                            'Bairro'      : 'descricaobairro',
                            'Município'   : 'descricaomunicipio',
                            'UF'          : 'iduf',
                            'Complemento' : 'referencia',
                            'Fone'        : 'fone1',
                            'E-mail'      : 'email',
                            'site'        : 'site'
                },
                json_meta: [
                    [
                        {
                            'key': 'charset',
                            'value': 'utf-8'
                        }
                    ]
                ],                
                ///////////////////////////////
                                
                options: {
                    format      : 'DD/MM/YYYY',
                    useCurrent  : false,
                    locale      : 'pt-BR'                       
                },

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'FORNECEDORES',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        initial_sort : false,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Nome/Razão social",
                        name: "nomerazaosocial",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "CPF/CNPJ",
                        name: "cpfcnpj",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "cnpjcpf_f",
                        row_classes: "def-col-cnpjcpf"
                    },
                    {
                        label: "Categoria",
                        name: "desccategoria",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }
                ],
                columnshiscomprasfor: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "idproduto",
                        sort: true,
                        initial_sort : false,
                        slot_name: "id_cp",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descricao",
                        name: "descpro",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        slot_name: 'slot_descricao',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Referência",
                        name: "referencia",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        slot_name: 'slot_referencia',
                        sort: false,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-right",
                       
                    },
                    {
                        label: "Marca",
                        name: "marca",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: false,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-right",

                    },  
                    {
                        label: "Localização",
                        name: "localizacao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: false,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-right",
                       
                    },
                    {
                        label: "Qtd.",
                        name: "quantidade",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        slot_name: 'slot_qtd_vend',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-right",
                       
                    },
                    {
                        label: "Estoque",
                        name: "saldo",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        slot_name: 'slot_qtd_estoque',
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-right",
                        
                    },
                 
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: true,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                configh: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdvisualizarestoque(produto){
                this.idprodutoestoque   = produto.idproduto;
                this.descproestoque     = produto.descpro;
                $('#mdestoqueproduto').modal('show');
            },
            mtdexportahistoricocompra(excel){

                let vself     = this;
                let filtro    = vself.mtdpreparafiltrohistcompra();
                let impexcel  = excel ? 1 : 0;
                let nomeidfor =  this.vidfornecedorhist + "-" + this.vdescfornecedorhist

                window.open(vself.$store.state.configpaths.pathcontrole+'rtcadfornecedores.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
                            '&oprelatorio=1'+
                            '&filtro='+filtro+
                            '&excel='+impexcel+
                            '&nomidfor='+nomeidfor.toUpperCase()+
                            '&filialpadrao='+vself.$store.state.filialpadrao.codfil+
                            '&usuario='+vself.$store.state.usuario.nome, '_blank');	
            },
            mtdexibehistoricocompras(fornecedor){
                this.lstcomprasfor          = [];

                this.vidfornecedorhist      = fornecedor.id;
                this.vdescfornecedorhist    = fornecedor.nomerazaosocial;
                
                this.isloadinghistcompras   = true;
                this.pfiltrodatacompra      = "1"
                this.pdtinicompra           = util.DataAtual(true);
                this.pdtfimcompra           = util.DataAtual(true);
               
                $('#mdlcompras').modal('show');
                this.mtdpesquisarhitoricocompras();

            },
            mtdpreparafiltrohistcompra(){
                let rfiltro = ` AND nf.idfornecedor=${this.vidfornecedorhist}`;

                if(parseInt(this.pfiltrodatavenda) === 1){
                    rfiltro +=` AND tp.dtentrada BETWEEN '${util.InverterData(this.pdtinicompra)}' AND '${util.InverterData(this.pdtfimcompra)}'`;
                }
                if(parseInt(this.pfiltrodatavenda) === 2){
                    rfiltro +=` AND tp.dtemissao BETWEEN '${util.InverterData(this.pdtinicompra)}' AND '${util.InverterData(this.pdtfimcompra)}'`;
                }
                if(parseInt(this.pfiltrodatavenda) === 3){
                    rfiltro +=` AND tp.dtefetivacao BETWEEN '${util.InverterData(this.pdtinicompra)} 00:00:00' AND '${util.InverterData(this.pdtfimcompra)} 23:59:59'`;
                }
                return rfiltro;
            },
            mtdpesquisarhitoricocompras(){
                let vself = this;
                let filtro = vself.mtdpreparafiltrohistcompra();
                vself.isloadinghistcompras = true;
                let parametros      = [
                    {parametro: 'idclientesac',  valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',            valor : 'comprasfor'},
                    {parametro: 'filtro',        valor : filtro},
                    {parametro: 'filialpadrao',  valor : vself.$store.state.filialpadrao.codfil},
                ];

                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfornecedores.php');
                retorno.then(function (response) {
                    vself.lstcomprasfor = response.data;
                    setTimeout(function (){
                            vself.isloadinghistcompras = false;
                    }, 1000);
                    
                }).catch(function (response) {
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.isloadinghistcompras = false;
                });
            },
            contultacnpj() {
                let vself    = this;
                //const cnpj = '12800976000128';
                const cnpj   = this.vcpfcnpj.replace(/[^0-9]/g,''); 
                const apiUrl = `https://www.receitaws.com.br/v1/cnpj/${cnpj}?callback=processData`;
        
                // Cria um script dinamicamente para fazer a requisição JSONP
                const script = document.createElement('script');
                script.src   = apiUrl;
        
                // Define uma função global para manipular os dados retornados
                window.processData = function(data) {
                    console.log(data);
                    // Remova o script após obter os dados, se necessário

                    vself.vnomerazaosocial        = data.nome;
                    vself.vfantasia               = data.fantasia;
                    vself.vdtnascimentofundacao   = data.data_situacao;   
                    vself.vemail                  = data.email;
                    vself.vfone1                  = data.telefone.replace(/[^0-9]/g,'');
                    vself.vcep                    = data.cep.replace(/[^0-9]/g,'');
                    vself.mtdpesquisacep();
                    //por aqui colocar mais campos se necessário - guga

                    document.head.removeChild(script);
                };
        
                // Adiciona o script à página para iniciar a requisição
                document.head.appendChild(script);
            },
            formatacpfcnpj(val) {
                return util.formatacpfcnpj(val);
            },
            mtdfiltropesquisa(){
                let rfiltro = '';
                console.log("inidep");
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and f.id='+this.pconteudo;
                }
                if(parseInt(this.pfiltro) === 1){
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(f.nomerazaosocial) like upper(\''+this.pconteudo+'%\')';
                }
                if(parseInt(this.pfiltro) === 2){
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(f.fantasia) like upper(\''+this.pconteudo+'%\')';
                }
                if(parseInt(this.pfiltro) === 3){
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(f.cpfcnpj) like upper(\''+this.pconteudo+'%\')';
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfornecedores.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregafornecedores(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregafornecedores(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                vself.$refs.reflstfornecedores.selected_items = [];
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfornecedores.php');
                retorno.then(function (response) {
                    vself.lstfornecedores = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstfornecedores = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

                this.vid                     = '';
                this.vcpfcnpj                = '';
                this.vrgie                   = '';
                this.vnomerazaosocial        = '';
                this.vfone1                  = '';
                this.vfone2                  = '';
                this.vemail                  = '';
                this.vsite                   = '';
                this.vdtnascimentofundacao   = '';
                this.vcontato                = '';
                this.vinscricaosuframa       = '';
                this.vfantasia               = '';
                this.vlogradouro             = '';
                this.vnumeroendereco         = '';
                this.vidbairro               = '';
                this.vidmunicipio            = '';
                this.viduf                   = '';
                this.vidpais                 = '1';
                this.vreferencia             = '';
                this.vcep                    = '';
                this.vobs                    = '';
                this.vtipo                   =  1;
                this.vtipocontribuinte       =  9;
                this.vativo                  =  0;
                this.vidcategoria            = null;

                $('#cbbairro').val(null).trigger('change');
                $('#cbmunicipio').val(null).trigger('change');
                $('#cbuf').val(null).trigger('change');
                $("#cbcategoria").val(null).trigger('change');
                $("#cbpais").val(null).trigger('change');                 
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) === 1) {
                        $('#cbtipo').focus();
                    } else if (parseInt(this.opcrud) === 2){
                        setTimeout(function(){
                            $('#edrazaosocial').focus();
                        },200)                        
                    }else {
                        setTimeout(function(){
                            $('#btgravar').focus();
                        },200)                                                  
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
                
            },
            mtdnovo(){
                if (!util.opcaousuario('002Z.001M.001L', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE FORNECEDORES';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.ativadesativa1 = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnimportacao').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdpesquisacep(){
                let vself = this;
                let cepinf = vself.vcep;
                if ( cepinf != ''){
                    if (util.IsCEP(cepinf, '')){
                        let loader = vself.$loading.show();
                        let parametros = [
                            {parametro: 'param1', 		valor: 'consultarcep'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'cep', 			valor: cepinf}
                        ];
                        let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/buscarcep.php');
                        retorno.then(function (response) {
                            loader.hide();
                            if (response.data != '0') {
                                
                                vself.vlogradouro       = response.data.logradouro;
                                vself.vreferencia       = response.data.complemento;

                                var defmun = new Option(response.data.descmunicipio, response.data.idmunicipio, true, true);
                                $('#cbmunicipio').append(defmun).trigger('change');

                                var defbai = new Option(response.data.descbairro, response.data.idbairro, true, true);
                                $('#cbbairro').append(defbai).trigger('change');

                                var defuf = new Option(response.data.descuf, response.data.iduf, true, true);
                                $('#cbuf').append(defuf).trigger('change');
                            }else{
                                vself.$toastr.w('CEP inválido ou inexistente!', 'Atenção!');
                            }					

                        }).catch(function (response) {
                            loader.hide();
                            console.log(response.message);
                        });
                    }
                }                
            },
            mtdlimpar_listagem() {
                this.lstfornecedores = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
                this.$refs.reflstfornecedores.selected_items = [];
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                if (vself.vtipo == 0 && vself.opcrud == 1) {
                if ((vself.vcpfcnpj.length < 11) || (util.validarCPF(vself.vcpfcnpj) == false)) {
                vself.$toastr.w("O CPF digitado é inválido!", "Atenção!");
                $("#edcpf").focus();
                return;
                }
                }
                if (vself.vtipo == 1 && vself.opcrud == 1) {
                    if ((vself.vcpfcnpj.length < 14) || (util.validarCNPJ(vself.vcpfcnpj) == false)) {
                    vself.$toastr.w("O CNPJ digitado é inválido!", "Atenção!");
                    $("#edcnpjfor").focus();
                    return;
                    }
                }
                // if (vself.vtipo == 1 && vself.vrgie != '') {
                //     if (util.validarIE(vself.vrgie, vself.viduf) === false) {
                //         vself.$toastr.w("A IE digitada é inválida!", "Atenção!");
                //         $("#edie").focus();
                //         return;
                //     }
                // }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and f.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfornecedores.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('002Z.001M.002L', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE FORNECEDORES';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.ativadesativa1 = true;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('002Z.001M.003L', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE FORNECEDORES';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.ativadesativa1 = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdselect2_def(){
                let vself = this;
                $("#cbcategoria").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbcategorias',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidcategoria = $("#cbcategoria").val();
                });
                $("#cbbairro").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbbairros',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 2,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidbairro = $("#cbbairro").val();
                });
                $("#cbmunicipio").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmunicipios',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 2,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidmunicipio = $("#cbmunicipio").val();
                });
                $("#cbuf").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbufs',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.viduf = $("#cbuf").val();
                });

                $("#cbpais").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbpaises',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidpais = $("#cbpais").val();
                });

                $("#edcep").blur(function(){
                    vself.mtdpesquisacep();
                });
                // SELECT 2 ATRIBUIR CAMPOS
                $("#cbcategoriacampos").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcategorias',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vcategoriacampos = $("#cbcategoriacampos").val();
                });
            },
            mtdigualarcampos(registro){
                this.vid                     = registro.id;
                this.vcpfcnpj                = registro.cpfcnpj;
                this.vrgie                   = registro.rgie;
                this.vnomerazaosocial        = registro.nomerazaosocial;
                this.vfone1                  = registro.fone1;
                this.vfone2                  = registro.fone2;
                this.vemail                  = registro.email;
                this.vsite                   = registro.site;
                this.vdtnascimentofundacao   = registro.dtnascimentofundacao;
                this.vcontato                = registro.contato;
                this.vinscricaosuframa       = registro.inscricaosuframa;
                this.vfantasia               = registro.fantasia;
                this.vlogradouro             = registro.logradouro;
                this.vnumeroendereco         = registro.numeroendereco;
                this.vreferencia             = registro.referencia;
                this.vcep                    = registro.cep;
                this.vobs                    = registro.obs;
                this.vtipo                   = registro.tipo;
                this.vtipocontribuinte       = registro.tipocontribuinte;
                this.vativo                  = registro.ativo;
                this.vidbairro               = registro.idbairro;
                this.vidmunicipio            = registro.idmunicipio;
                this.viduf                   = registro.iduf;
                this.vidpais                 = registro.idpais;
                this.vidcategoria            = registro.idcategoria === 0 ? null : registro.idcategoria; 

                var defmunicipio = new Option(registro.descricaomunicipio, this.vidmunicipio, true, true);
                $('#cbmunicipio').append(defmunicipio).trigger('change');

                var defbairro = new Option(registro.descricaobairro, this.vidbairro, true, true);
                $('#cbbairro').append(defbairro).trigger('change');

                var defuf = new Option(registro.descricaouf, this.viduf, true, true);
                $('#cbuf').append(defuf).trigger('change');

                var deffpais = new Option(registro.descpais, this.vidpais, true, true);
                $('#cbpais').append(deffpais).trigger('change');

                if (this.vidcategoria !== null){
                    var defcat                = new Option(registro.desccategoria, registro.idcategoria, true, true);
                    $('#cbcategoria').append(defcat).trigger('change');                
                }else{
                    $('#cbcategoria').val(null).trigger('change');
                }
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                         : this.vid,
                    'cpfcnpj'                    : this.vcpfcnpj,
                    'idcategoria'                : this.vidcategoria === null ? 0 : this.vidcategoria, 
                    'rgie'                       : this.vrgie,
                    'nomerazaosocial'            : this.vnomerazaosocial,
                    'fone1'                      : this.vfone1,
                    'fone2'                      : this.vfone2,
                    'email'                      : this.vemail,
                    'site'                       : this.vsite,
                    'dtnascimentofundacao'       : this.vdtnascimentofundacao,
                    'contato'                    : this.vcontato,
                    'inscricaosuframa'           : this.vinscricaosuframa,
                    'fantasia'                   : this.vfantasia,
                    'logradouro'                 : this.vlogradouro,
                    'referencia'                 : this.vreferencia,
                    'cep'                        : this.vcep,
                    'obs'                        : this.vobs,
                    'tipo'                       : this.vtipo,
                    'tipocontribuinte'           : this.vtipocontribuinte,   
                    'ativo'                      : this.vativo,
                    'idbairro'                   : this.vidbairro,
                    'iduf'                       : this.viduf,
                    'idpais'                     : this.vidpais,
                    'idmunicipio'                : this.vidmunicipio,
                    'numeroendereco'             : this.vnumeroendereco
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '002Z.001M.001L' : parseInt(this.opcrud) === 2 ? '002Z.001M.002L' : '002Z.001M.003L'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfornecedores.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregafornecedores(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdrotinaimportacao(){
                if (!util.opcaousuario('002Z.001M.004L', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'IMPORTAÇÃO DE CADASTRO DE FORNECEDORES';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    $('#pnlista').hide();
                    this.resetarDados();
                    this.arqselecionado = null;
                    this.vlimpardados   = false;
                    $('#pnimportacao').fadeIn(700);
                }                
            },
            mtdbaixarmatriz(){
                window.open('https://www.rillsoft-app.cloud/controller/arquivosimportacao/manager/matrizes/matrizimportarfornecedores.xls', '_blank');
            },
            mtdselecionararquivo(event){                
                let vself            = this;                 
                vself.arqselecionado = event.target.files[0];

                let extarq  = vself.arqselecionado.name.substring(vself.arqselecionado.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'XLS'){
                    vself.arqselecionado = null;
                    vself.$toastr.w('O arquivo selecionado não possui um formato válido', 'Atenção!');
                    return;
                }

                let loader      = vself.$loading.show();
                let localsalvar = 'controller/arquivosimportacao/manager/'+
                                  vself.$store.state.filialpadrao.idcliente;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.mtdcancelaredicao();
                        vself.lstfornecedores= [];
                        vself.pqtd_paginas   = 0;                                                
                        let oplimpar         = vself.vlimpardados === false ? '0' : '1';
                        let url              = 'https://www.'+vself.$store.state.usuario.adrsrv+'/controller/importadores/manager/importarfornecedores.php?idclientesac='+vself.$store.state.filialpadrao.idcliente+
                                               '&arquivoimportar='+vself.arqselecionado.name+'&limparcadastro='+oplimpar+
                                               '&idfilial='+vself.$store.state.filialpadrao.codfil+'&idu='+
                                               vself.$store.state.usuario.id+'&codop=002Z.001M.004L';
                        vself.arqselecionado = null;                                               
                        window.open(url, '_blank');                        
                    }else{
                        vself.arqselecionado = null;
                        $('#ipselecionararquivo').val('');
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.arqselecionado = null;
                    $('#ipselecionararquivo').val('');
                });                
            },
            mtdexportarexcel(){
                $('#btexportarexcel').click();
            },
            mtdrotinacampos(){
                let vself = this;
                if (!util.opcaousuario('002Z.001M.005L', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    if (this.$refs.reflstfornecedores.selected_items.length === 0){
                        this.$toastr.w('Selecione os fornecedores para a atribuição dos campos!', 'Atenção!');
                        return;
                    }

                    vself.vatribuirtipocontribuinte = false;
                    vself.vatribuircategoria        = false;
                    vself.vtipocontribuintecampos   = 9;

                    $('#cbcategoriacampos').val(null).trigger('change');
                    $('#mdatribuircampos').modal('show');
                }    
            },
            mtdatribuircampos(){
                let vself = this;

                if (!this.vatribuirtipocontribuinte && !this.vatribuircategoria){
					this.$toastr.w('Selecione ao menos um campo para a atribuição!', 'Atenção!');
					return;
                }
				if (this.vatribuirtipocontribuinte === true && this.vtipocontribuintecampos === ''){
					this.$toastr.w('Campo "Atribuir contribuinte" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbatribuirtipocontribuinte').focus();
					return;
                }
				if (this.vatribuircategoria === true && this.vcategoriacampos === null){
					this.$toastr.w('Campo "Categorias" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbcategoriacampos').focus();
					return;
                }
				
                let stratribuir = "";

                if (this.vatribuirtipocontribuinte){
                    stratribuir = stratribuir + 'tipocontribuinte="'+this.vtipocontribuintecampos+'", ';
                }
                if (this.vatribuircategoria){
                    stratribuir = stratribuir + 'idcategoria='+this.vcategoriacampos+', ';
                }
                if (stratribuir !== ""){
                    stratribuir = stratribuir.substring(0, stratribuir.length - 2);//remove a ", " do final da string
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a atribuição dos campos aos fornecedores selecionados?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: true,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                this.buttons.sim.disable();
                                setTimeout(function(){
                                    let lstfornecedoratribuir = '';
                                    for (let produto of vself.$refs.reflstfornecedores.selected_items) {
                                        lstfornecedoratribuir = lstfornecedoratribuir + produto.id + ', ';
                                    }
                                    lstfornecedoratribuir = lstfornecedoratribuir.substring(0, lstfornecedoratribuir.length - 2);//remove a ", " do final da string
                                    let loader = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',               valor : 'atribuircampos'},
                                        {parametro: 'stratribuir',      valor : stratribuir},
                                        {parametro: 'fornecedores',     valor : lstfornecedoratribuir},
                                        {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',            valor : '002Z.001M.005L'},
                                    ];
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfornecedores.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data)){
                                            $('#mdatribuircampos').modal('hide');
                                            vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                                            vself.pqtd_paginas  = 1;
                                            vself.mtdcancelaredicao();
                                            vself.mtdcarregafornecedores(1);
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'I':
                                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });
                                },200);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btconfirmar').focus();
                            }
                        }
                    }
                });
            },
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('002Z.001M', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtdexecutapesquisa();
                        vself.mtdselect2_def();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vnomerazaosocial === '' || this.vcpfcnpj === '' || this.vfone1 === '' ||
                this.vdtnascimentofundacao === '' || this.vcep === '' || this.vlogradouro === '' || 
                this.vnumeroendereco === '' || this.vnumeroendereco === '' || this.viduf == null || 
                this.vidbairro == null || this.vidmunicipio == null;
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregafornecedores(val);
            }
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    .modal-hist-compras{
        max-width: 950px !important;
    }
</style>